import { makeStyles } from "@mui/styles";
import { color } from "../../../Config/theme";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "2% !important",
    marginBottom: "50px !important",
  },
  buttonStyle: {
    width: "300px",
    "@media (max-width:640px)": {
      width: "280px",
    },
    "@media (max-width:600px)": {
      width: "240px",
    },
    "@media (max-width:525px)": {
      width: "180px",
    },
    "@media (max-width:425px)": {
      width: "160px",
    },
    "@media (max-width:375px)": {
      width: "130px",
    },
  },
  fullWidth: {
    "@media (max-width:425px)": {
      width: "100%",
    },
  },
  bottomView: {
    "@media (max-width:768px)": {
      position: "absolute",
      bottom: 80,
      left: 0,
      right: 0,
      padding: "0px 16px",
    },
  },
  steppermain: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 46,
    width: 46,
    borderRadius: "50%",
    backgroundColor: color.primary,
    "@media (max-width:768px)": {
      height: 36,
      width: 36,
    },
    "@media (max-width:425px)": {
      height: 26,
      width: 26,
    },
  },
  lineMain: {
    display: "flex",
    flex: "1 1",
    width: "100%",
    height: 4,
  },
  radiomain: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },
  loaderView: {
    width: "100%",
    minHeight: 400,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sectionTitle: {
    color: color.primary,
    fontFamily: "PoppinsSemiBold !important",
    fontSize: "20px !important",
  },
}));

export default useStyles;
